var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "estatisticas az-card-bordered",
      class: { "estatisticas--loading": _vm.loading }
    },
    [
      _c(
        "FeedbackWrapper",
        {
          attrs: {
            loading: _vm.loading,
            message: _vm.WALLET_EMPTY_MESSAGE,
            minHeight: _vm.cardMinHeight
          }
        },
        [
          _c(
            "div",
            { staticClass: "estatisticas__header" },
            [
              _c("span", { staticClass: "az-ds-card-title" }, [
                _vm._v(" Estatísticas ")
              ]),
              _c(
                "v-tooltip",
                {
                  attrs: { right: "", "max-width": "360" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "icon-svg",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    name: "mdi-information",
                                    size: "16",
                                    color: "#8E8E8E"
                                  }
                                },
                                "icon-svg",
                                attrs,
                                false
                              ),
                              on
                            )
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("span", [
                    _vm._v(
                      " A carteira atual é cotizada com base nos ativos e movimentações que você/seu cliente cadastra na plataforma. O sistema nivela a análise em D-3, conforme disponibilização das cotas dos fundos pela CVM. As rotinas de atualização da cotização são feitas diariamente, automaticamente. "
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "estatisticas__portfolio" },
            [
              _vm._l(_vm.analisePortifolio, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "estatisticas__portfolio-item" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "az-text-primary az-size-14 font-semibold mr-1"
                          },
                          [_vm._v(_vm._s(item.topic))]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { right: "", "max-width": "360" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "icon-svg",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                name: "mdi-information",
                                                size: "14",
                                                color: "#8E8E8E"
                                              }
                                            },
                                            "icon-svg",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(" " + _vm._s(item.info) + " ")])]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "estatisticas__portfolio-text az-text-primary az-size-14 font-bold"
                      },
                      [_vm._v(" " + _vm._s(item.value) + " ")]
                    )
                  ]
                )
              }),
              !_vm.hideVerMais
                ? _c(
                    "BaseButton",
                    {
                      staticClass: "estatisticas__portfolio-button",
                      attrs: { secondary: "", text: "", sm: "", small: "" },
                      on: { click: _vm.toAnalisePortf }
                    },
                    [
                      _c("icon-svg", {
                        attrs: { name: "mdi-eye", size: "20", color: "primary" }
                      }),
                      _vm._v(" Ver mais ")
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _c("div", { staticClass: "estatisticas__rentabilidade" }, [
            _c(
              "div",
              { staticClass: "az-text-primary az-size-14 font-semibold" },
              [_vm._v("Rentabilidade Relativa")]
            ),
            _c(
              "div",
              { staticClass: "estatisticas__rentabilidade-container" },
              _vm._l(_vm.rentRelativa, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "estatisticas__rentabilidade-item"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "estatisticas__rentabilidade-text az-text-primary az-size-14 az-muted"
                      },
                      [
                        item.text === "CDI"
                          ? [
                              _c("strong", [_vm._v(_vm._s(item.value))]),
                              _c("span", [_vm._v(_vm._s(item.text))])
                            ]
                          : [
                              _c("span", [_vm._v(_vm._s(item.text))]),
                              _c("strong", [_vm._v(_vm._s(item.value))])
                            ]
                      ],
                      2
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._t("nota")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }